import React, {useState, useEffect} from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import PropertyCard from "../PropertyCard/PropertyCard";
import Slider from "react-slick";
import $ from "jquery";
import { ApiRequest } from "../../common/utils/api_request_utils";
import { graphql, useStaticQuery } from "gatsby";

import "../Features/Features.scss";

const SimilarProperty = ({property_data, slider_count}) => {

    const data =useStaticQuery(graphql`
    query OfficeContactQuerySimilar{
        glstrapi {
            offices {
                office_crm_id
                mobile
                email
            }
        }
    }`)

    var offices = data.glstrapi?.offices;

    const [modalShow, setModalShow] = React.useState(false);
    const [book_a_viewing_link, setViewingLink] = React.useState("");

    const [propItems, setPropItems] = useState([])

    useEffect(() => {
        if(property_data?.id){
            //console.log("property_data officeDepartment", property_data?.officeDepartment)
            
            let similar_prop_url = `${process.env.GATSBY_STRAPI_SRC}/stb-lists/item/property-details?pid=${property_data?.id}`;

            if(property_data?.officeDepartment === "investments"){
                similar_prop_url = `${process.env.GATSBY_STRAPI_SRC}/properties?search_type=sales&_limit=12&_sort=published_at:DESC&publish=true&department=residential&status=For Sale&officeDepartment=investments&id_ne=${property_data?.id}`
            }
            ApiRequest({
                method: "GET",
                url: similar_prop_url
            }, (result) => {
                if (result.length > 0) {
                    setPropItems(result)
                }
            })
        }
    }, [property_data]);
    
    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        mobileFirst: true,
        afterChange: (event) => {
            var activeDotEl = $('.features .slick-slider').find('.slick-dots').find('li.slick-active');
            if(activeDotEl.get(0)){
                activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
            
        },
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    dots: false,
                    arrows: true,
                    slidesToShow: slider_count || 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots:true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    //console.log("property_data officeDepartment", property_data)

    return (
        <React.Fragment>
            {propItems.length > 0 && 
            <section className="features similar_property">

                <Row>
                    <Col>
                        <h2>{property_data?.officeDepartment === "investments" ? "Explore Investment properties" : "May also interest you"}</h2>

                        <div className="tab-wrapper">    
                            <Slider {...settings}>
                                {propItems?.map((item, index) => (
                                    <PropertyCard key={index} FeaturesList={item} offices={offices} setModalShow={setModalShow} setViewingLink={setViewingLink} officeDepartment={property_data?.officeDepartment} />
                                ))}
                            </Slider>
                        </div>
                    </Col>
                </Row>


                <Modal
                    show={modalShow}
                    onHide={() => {setModalShow(false); setViewingLink("")}}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter" className="book_a_viewing_ttl">
                            Book a Viewing
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="team_content col-md-12 col-lg-18 p-0">
                            <iframe src={book_a_viewing_link} height="600" width={"100%"} className="book_a_viewing" />
                        </div>
                    </Modal.Body>
                </Modal>
            </section>
            }
        </React.Fragment>
    );
};
export default SimilarProperty;
